export const RANDOMIZER_VERSION = "2.0.0-beta";